exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".error-404 .c-link {\n  display: inline-block;\n  margin-top: .5rem;\n  font-size: 1.25rem; }\n", "", {"version":3,"sources":["/tmp/build_3f9f81bc/src/containers/Errors/Error404/src/containers/Errors/Error404/Error404.scss"],"names":[],"mappings":"AACA;EAEQ,sBAAqB;EACrB,kBAAiB;EACjB,mBAAkB,EACrB","file":"Error404.scss","sourcesContent":["@import \"variables\"; @import \"mixins\";\n.error-404 {\n    .c-link {\n        display: inline-block;\n        margin-top: .5rem;\n        font-size: 1.25rem;\n    }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true,"data":"@import /"variables/"; @import /"mixins/";","includePaths":["/tmp/build_3f9f81bc/src/scss"]}!./src/containers/Errors/Error404/Error404.scss
// module id = 670
// module chunks = 0